module.exports = __webpack_public_path__ + "img/steps.cc8ff43c.svg";